























































































import { CatalogoInterface } from '@/models'
import store from '@/store'
import useAppConfig from '@core/@app-config/useAppConfig'
import useSweetAlert from '@core/plugins/sweetalert'
import { required } from '@core/utils/validation'
import { mdiFileDocumentEditOutline, mdiFileDocumentMultipleOutline } from '@mdi/js'
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api'

export default defineComponent({
  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
    codigo: {
      type: String,
      default: null,
    },
  },
  emits: ['modalOnClose'],
  setup(props, { emit }) {
    const catalogo = computed<CatalogoInterface>(() => store.getters['catalogo/catalogo'])
    const catalogoForm: any = ref(null)
    const catalogoData = ref<CatalogoInterface>({
      catalogoId: null,
      codigo: null,
      descripcion: null,
      nombre: null,
      referenciaCodigo: null,
      valor1: null,
      valor2: null,
    })

    const { isLoading } = useAppConfig()
    const { showMessage } = useSweetAlert()

    onMounted(() => {
      if (catalogo.value.catalogoId) {
        obtenerCatalogo()
      }

      if (props.codigo) {
        catalogoData.value.referenciaCodigo = props.codigo
      }
    })

    const obtenerCatalogo = async () => {
      isLoading.value = true
      const { ok, response } = await store.dispatch('catalogo/obtenerCatalogo', catalogo.value.catalogoId)

      if (ok) {
        cargarCatalogo(response)
      }
      isLoading.value = false
    }

    const cargarCatalogo = (response: CatalogoInterface) => {
      catalogoData.value.catalogoId = response.catalogoId
      catalogoData.value.codigo = response.codigo
      catalogoData.value.descripcion = response.descripcion
      catalogoData.value.estado = response.estado
      catalogoData.value.nombre = response.nombre
      catalogoData.value.referenciaCodigo = response.referenciaCodigo
      catalogoData.value.valor1 = response.valor1
      catalogoData.value.valor2 = response.valor2
    }

    const handleFormValidation = async () => {
      if (!catalogoForm.value.validate()) {
        return
      }

      isLoading.value = true
      const { ok, response } = await store.dispatch('catalogo/guardarCatalogo', catalogoData.value)

      if (ok) {
        showMessage('Éxito!', response.mensaje, 'success')
        cerrarNodal(true)
      }
      isLoading.value = false
    }

    const cerrarNodal = (actualizar: boolean) => {
      store.commit('catalogo/limpiarCatalogo')
      // catalogoForm.value.reset()
      emit('modalOnClose', actualizar)
    }

    return {
      cerrarNodal,
      handleFormValidation,
      catalogoData,
      catalogoForm,
      icons: {
        mdiFileDocumentEditOutline,
        mdiFileDocumentMultipleOutline,
      },
      validators: {
        required,
      },
    }
  },
})
